"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeEditorSelectors = makeEditorSelectors;
function makeEditorSelectors(name, options, resource) {
    let scope = state => {
        let scopeName = state[name + "Editor"];
        if (!scopeName) {
            throw new Error("Register reducer of resource " + name + " in the store under: \"" + name + "Editor\"");
        }
        return scopeName;
    };
    return {
        creating: state => scope(state).creating,
        deleting: state => scope(state).deleting,
        error: state => scope(state).error,
        isItem: item => state => resource.hasSameId(item, scope(state).item),
        item: state => scope(state).item,
        original: item => resource.selectors.itemByItem(item),
        reading: state => scope(state).reading,
        updating: state => scope(state).updating
    };
}
//# sourceMappingURL=makeEditorSelectors.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/editor/makeEditorSelectors.js